import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class JobScheduleSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
    {
      label: 'label.status',
      name: 'status',
      tOptions: 'selections:jobStatus',
      isClearable: true,
      type: 'select',
    },
  ];

  btnSpan = 'col-md-3';
}

JobScheduleSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

JobScheduleSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(JobScheduleSearchForm);
